import React, { useEffect, useState } from "react";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { useFormik } from "formik";
import { v4 as uuidv4 } from "uuid";
import { useDispatch } from "react-redux";
import { SET_NAVBAR_TITLE } from "action_creators/actioncreator";

// Material UI Components
import { Alert } from "@material-ui/lab";
import { FormControl, IconButton, TextField, Button } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import MenuItem from "@material-ui/core/MenuItem";
import Paper from "@material-ui/core/Paper";
import Select from "@material-ui/core/Select";
import Typography from "@material-ui/core/Typography";

// Icons
import Visibility from "@material-ui/icons/Visibility";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";

// Local
import CustomTable from "./Table";
import LoaderHoc from "../../../components/HOC/LoaderHoc";
import { SDCloudBackendAPIWithToken } from "../../../apis/backendAPI";
// import { IconButton } from "@material-ui/core";
import RightDrawer from "./RightDrawer";
import AddUser from "./AddUser";
import UserDetails from "./UserDetails";
import { Add } from "@material-ui/icons";
import InputAdornment from "@material-ui/core/InputAdornment";
import SearchIcon from "@material-ui/icons/Search";
import ShimmerUserTable from "./ShimmerUserTable";
// Styling
const useStyles = makeStyles((theme) => ({
  root: {
    // padding: "30px 20px",
  },
}));

const SignUpRequests = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const profileData = JSON.parse(localStorage.getItem("profileData"));
  const account = profileData.account;
  let domain = JSON.parse(localStorage.getItem("internal_domains"))?.domains;
  let userEmail = JSON.parse(localStorage.getItem("profileData"))?.email;
  let hasDomain = domain?.some((res) => userEmail.includes(res));
  const [isInternal, setIsInternal] = useState(hasDomain);
  useEffect(() => {
    dispatch(SET_NAVBAR_TITLE(isInternal ? account + "  - Sign Up Requests" : "Sign Up Requests"));
  }, []);
  // States
  const [rows, setRows] = useState([]);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [currentScreen, setCurrentScreen] = useState();
  const [currentUser, setCurrentUser] = useState("");
  const [signUpStatus, setSignUpStatus] = useState("Open");
  const [profileList, setProfileList] = useState({});
  const [showNotification, setShowNotification] = useState(false);
  const [notificationMessage, setNotificationMessage] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [recordCount, setrecordCount] = useState(10);
  const [searchValue, setsearchvalue] = useState("");
  const [pageNo, setpageNo] = useState(1);
  const [rowstemp, setrowstemp] = useState([]); 
  // useEffects
  useEffect(() => {
    renderData(pageNo,recordCount,searchValue,signUpStatus);
  }, [pageNo,recordCount,searchValue,signUpStatus]);

  // useEffect(() => {
  //   renderData(pageNo,recordCount,searchValue);
  // }, [signUpStatus]);

  const columns = [
    {
      Header: "Email",
      accessor: "email",
    },
    {
      Header: "Name",
      accessor: "name",
    },
    {
      Header: "Invite Code",
      accessor: "invite_code",
    },
    {
      Header: "Permission Profile",
      accessor: "profile",
      width: 350,
    },
    {
      Header: "Status",
      accessor: "status",
    },
  ];

  const filterDropDownValues = ["Open", "Rejected", "All"];

  let data = [];
  const [permissionProfiles, setPermissionProfiles] = useState({});
  const renderData = async (page_no,record_count,search_value,status) => {
    let profiles = await renderProfileDropdown();

    let response = SDCloudBackendAPIWithToken()
      .get(`/get_pending_user_requests?search=${search_value ??
          searchValue}&page_no=${
          page_no ? page_no : pageNo
        }&record_count=${record_count? record_count:recordCount}&signupstatus=${status}`)
      .then((resp) => {
        return resp.data;
      })
      .then((resp) => {
        resp.pending_user_requests.forEach(async (item) => {
          if (item.status === signUpStatus || signUpStatus === "All") {
            data.push({
              id: item.id,
              email: item.email,
              name: `${item.first_name} ${item.last_name}`,
              invite_code: item.invitation_code,
              profile: (
                <FormControl
                  variant="filled"
                  style={{ marginTop: "0", marginRight: "5px" }}
                >
                  <Autocomplete
                    id={`profile_dropdown_${item.id}`}
                    options={profiles}
                    getOptionLabel={(option) => option.label || ""}
                    isOptionEqualToValue={(option, value) => option.value === value.value}
                    value={permissionProfiles[item.id]}
                    onChange={(event, newValue) => {
                      setPermissionProfiles((prev) => ({
                        ...prev,
                        [item.id]: newValue
                      }));
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="filled"
                        fullWidth
                        // error={!permissionProfiles[item.id]}
                        // helperText={!permissionProfiles[item.id] ? "Required" : ""}
                      />
                    )}
                    style={{ minWidth: "250px" }}
                  />
                  {/* <Select
                    labelId="demo-simple-select-filled-label"
                    id="demo-simple-select-filled"
                    fullWidth
                    name="permission_profile"
                    // defaultValue={profiles[0].profile_name}
                    style={{ minWidth: "250px" }}
                    native
                    inputProps={{ id: `profile_dropdown_${item.id}` }}
                  >
                    {profiles}
                  </Select> */}
                </FormControl>
              ),
              status: (
                <FormControl
                  variant="filled"
                  style={{ marginTop: "0", marginRight: "5px" }}
                >
                  <Select
                    labelId="demo-simple-select-filled-label"
                    id={`demo-simple-select-filled_${item.id}`}
                    fullWidth
                    name={`status_${item.id}`}
                    style={{ minWidth: "200px" }}
                    native={true}
                    inputProps={{ id: `status_dropdown_${item.id}` }}
                  >
                    <option value="" selected>
                      None
                    </option>
                    <option value="accept">Accept</option>
                    <option value="reject">Reject</option>
                  </Select>
                </FormControl>
              ),
            });
          }
        });

        setRows(data);
        setIsLoading(false);
        setrowstemp(resp)
      });
  };

  const renderProfileDropdown = async () => {
  //   // const profileItems = SDCloudBackendAPIWithToken.get("/get_profile")
  //   //   .then((resp) => resp.data)
  //   //   .then((data) => {
  //   //     let profiles = data.profiles;

  //   //     let items = profiles.map((item) => {
  //   //       return (
  //   //         <option key={uuidv4()} value={item.profile_name}>
  //   //           {item.profile_name}
  //   //         </option>
  //   //       );
  //   //     });

  //   //     return (
  //   //       <FormControl variant="filled" style={{ marginTop: "0" }}>
  //   //         <Select
  //   //           labelId="demo-simple-select-filled-label"
  //   //           id="demo-simple-select-filled"
  //   //           fullWidth
  //   //           name="permission_profile"
  //   //           defaultValue={profiles[0].profile_name}
  //   //           style={{ minWidth: "250px" }}
  //   //           native
  //   //           inputProps={{ id: `profile_dropdown_${1}` }}
  //   //         >
  //   //           {items}
  //   //         </Select>
  //   //       </FormControl>
  //   //     );
  //   //   });

    let profileItems = await SDCloudBackendAPIWithToken().get("/list_profiles");
    // profileItems = profileItems.data.profiles.map((item) => {
    //   return (
    //     <option key={uuidv4()} value={item.profile_name}>
    //       {item.profile_name}
    //     </option>
    //   );
    // });
    profileItems = profileItems.data.profile_data.map((item) => ({
      label: item.profile_name,
      value: item.profile_name
    }));

    return profileItems;
  };

  const renderDrawerComponent = () => {
    switch (currentScreen) {
      case "Add User":
        return <AddUser />;
      case "User Details":
        return <UserDetails user={currentUser} />;
      case "default":
        return null;
    }
  };

  const handleSubmitButton = (selectedFlatRows) => {
    let payload = {
      update_pending_requests: [],
    };

    let responses = [];

    selectedFlatRows.forEach((item) => {
      let id = item.original.id;
      let action = document.getElementById(
        `status_dropdown_${item.original.id}`
      ).value;
      let profile = document.getElementById(
        `profile_dropdown_${item.original.id}`
      ).value;

      payload.update_pending_requests.push({
        id: id,
        action: action,
        reference_profile_name: profile,
        base_url: `https://${window.location.host}/auth/`,
      });
    });
    
    let response = SDCloudBackendAPIWithToken()
      .post("/update_pending_user_request", payload)
      .then((resp) => resp.data)
      .then((data) => {
        responses = [...data.response];
        setShowNotification(true);
        setNotificationMessage(responses);
        renderData(pageNo,recordCount,searchValue,signUpStatus);
      });
  };

  const handleDeleteButton = (selectedRowIds, selectedFlatRows) => {
    let payload = {};
    selectedFlatRows.forEach((item) => {
      let id = item.original.id;

      SDCloudBackendAPIWithToken()
        .post(`/delete_pending_user_request/${id}`)
        .then((resp) => resp.data)
        .then((data) => {
          renderData(pageNo,recordCount,searchValue,signUpStatus);
        });
    });
  };
  const handleDataSearch = (search_value) => {
    setsearchvalue(search_value);
  };
  const handlePagination = (page_no,record_count) => {
    setrecordCount(record_count)
    setpageNo(page_no);
  };
  const handleViewButton = (username) => {
    setOpenDrawer(true);
    setCurrentScreen("User Details");
    setCurrentUser(username);
  };
  const handleDropDown = (event)=>{
    setSignUpStatus(event)
    renderData(1,10,searchValue,event)
  }
  const renderNotififications = () => {
    let notifications = notificationMessage.map((item) => {
      let notificationType = item.success ? "success" : "error";
      return (
        <Alert
          onClose={() => setShowNotification(false)}
          severity={notificationType}
          spacing={1}
        >
          {item.message}
        </Alert>
      );
    });

    return notifications;
  };

  return (
    <div>
      <Button
        startIcon={<ArrowBackIcon />}
        onClick={() => window.location.assign("/settings")}
        style={{ margin: "16px 0" }}
        color="secondary"
        variant="outlined"
      >
        Back
      </Button>
      <Grid container className={classes.root} spacing={1}>
        <Grid item xs={12} md={12}>
          {showNotification ? renderNotififications() : null}
        </Grid>
        <Grid item xs={12} md={12}>
                    {isLoading ? (
                        <ShimmerUserTable />
                      ) : (
                        <CustomTable
                          columns={columns}
                          data={rows}
                          handleDeleteButtonClick={handleDeleteButton}
                          handleButtonClick={handleSubmitButton}
                          handleViewButtonClick={handleViewButton}
                          tableTitle="Sign Up Requests"
                          buttonTitle="Submit Request"
                          dropDownValues={filterDropDownValues}
                          handleDropDownChange={handleDropDown}
                          hiddenColumns={[]}
                          showDropdown={true}
                          count={rowstemp?.pagination?.total_pages}
                          page={rowstemp?.pagination?.current_page}
                          setList={handlePagination}
                          handleSearch={handleDataSearch}
                        />
                      )}
         
        </Grid>
      </Grid>

      {/* Drawer */}
      <RightDrawer
        open={openDrawer}
        onClose={setOpenDrawer}
        title={currentScreen}
      >
        {renderDrawerComponent()}
      </RightDrawer>
    </div>
  );
};

export default SignUpRequests;
